export enum RequestTaxInvoiceType {
  empty = 0,
  sent = 1,
  notNeed = 2
}

export enum RelateTaxInvoiceType {
  package = 1,
  customcostcode = 2
}
